import React, { useEffect, useState } from 'react';
import { Content, LeftSection, Logo, Main, Overlay, ButtonRow } from './landingPage.style';
import { Label, Button } from '../../../components/uielements';
import { AuthPage } from '../login';
import { UrbanCompassLogo } from '../../../icons';
import backgroundImg from '../../../assets/PNG/landing-page-background.png';
import backgroundImgCompress from '../../../assets/PNG/landing-page-compress.png';
import ChatBotModal from '../chatBot/chatBotModal';
// import CityOfOretonLogo from '../../../settings/moretonBayLogo';

const LandingPage = () => {
  const [step, setStep] = useState('landingPage');
  const [bgImage, setBgImage] = useState(backgroundImgCompress); // Load compressed first

  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = backgroundImg;
    img.onload = () => setBgImage(backgroundImg); // Replace with high-quality image once loaded
  }, []);

  const handleClick = () => {
    setStep('Auth');
  };

  const handleOpenPlanningEnquiry = () => {
    setIsChatOpen(true);
  };

  const handleKeyPress = (event, action) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      action();
    }
  };

  return (
    <>
      {step === 'landingPage' ? (
        <Main
          role="main"
          aria-label="Urban Compass Planning Digital Assistant Landing Page"
          bg={bgImage}
        >
          <header role="banner">
            <Logo>
              <UrbanCompassLogo role="img" aria-label="Urban Compass Logo" />
              {/* <CityOfOretonLogo color={'#fff'} role="img" aria-label="Moreton Bay Council Logo" /> */}
            </Logo>
          </header>

          <Overlay>
            <Content>
              <LeftSection>
                <h1 id="main-heading">
                  <Label size="header1" aria-level="1">
                    Welcome to the Urban Planning Digital Assistant
                  </Label>
                </h1>
                <ButtonRow role="group" aria-labelledby="main-heading">
                  <Button
                    onClick={handleOpenPlanningEnquiry}
                    onKeyPress={(e) => handleKeyPress(e, handleOpenPlanningEnquiry)}
                    aria-label="Start a planning enquiry using the chat assistant"
                    type="button"
                    tabIndex={0}
                  >
                    Planning Enquiry
                  </Button>
                  <Button
                    onClick={handleClick}
                    onKeyPress={(e) => handleKeyPress(e, handleClick)}
                    aria-label="Begin using the Urban Compass application"
                    type="button"
                    tabIndex={0}
                  >
                    Let&lsquo;s Begin
                  </Button>
                </ButtonRow>
              </LeftSection>
            </Content>
          </Overlay>
          <ChatBotModal
            isOpen={isChatOpen}
            onClose={() => setIsChatOpen(false)}
            aria-label="Planning Enquiry Chat Modal"
          />
        </Main>
      ) : (
        <AuthPage />
      )}
    </>
  );
};

export default LandingPage;
